import { useUser } from '@libs/contexts';
import { GlobalArea } from '@libs/templates/global-area';
import { AuthErrorViewWithBox } from '@libs/templates/template-pages';
import { BackDropSpinnerProvider } from '@ps-smart-cp/ppfw-client';
import { Outlet } from 'react-router';

function AuthorizedContainer() {
  const { user } = useUser();

  return (
    <BackDropSpinnerProvider>
      <GlobalArea homePath="/system-management/main-menu" isUnderSubsystem={false} />
      {!user || (user.type === 'IAM' && !user.isAdmin) ? <AuthErrorViewWithBox /> : <Outlet />}
    </BackDropSpinnerProvider>
  );
}

export { AuthorizedContainer };
